import useFeatureFlags from 'hooks/useFeatureFlags'
import type React from 'react'
import TeamListLegacy from './TeamListLegacy'
import TeamListV2 from './TeamListV2'

const TeamList: React.FC = () => {
  const flags = useFeatureFlags({
    flagNames: ['roles_permissions_v2'] as const
  })?.data

  const rolesPermissionsV2Enabled = flags?.roles_permissions_v2.enabled ?? false

  return rolesPermissionsV2Enabled ? <TeamListV2 /> : <TeamListLegacy />
}

export default TeamList
